import React, { useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button,Modal } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { taskmanagementschema } from "../../../../JsonData/CreateTaskConfig";
import DynamicTabs from "../../Common/Tabs/Tabs";
import { toast, ToastContainer } from "react-toastify";
import FormHandler from "../../Common/Form/FormHandler/FormHandler";
import useFormPersist from "react-hook-form-persist";
import { TaskFormConfig } from "../../../../JsonData/CreateTaskConfig";
import { useTranslation } from "react-i18next";

import {
  getData,
  postDataWithBody,
  putDataWithBody,
  editData,
} from "../../../../Services/Services";
import {
  getTaskConfigsURL,
  getAllActiveRole,
  createTaskURL,
  findTaskById,
  getTaskListURL,
  updateTaskURL,
  getThemeURL,
} from "../../../../Services/EndPoints";
import Loader from "react-spinner-loader";
import { downloadFile } from "../../../../Components/UiComponents/utils";
import { PaperClipIcon, Rejectedicon } from "../../../../Components/IconComponents";
import { FileText } from "lucide-react";
import PreviewFile from "../../Common/Form/PreviewFile/PreviewFile";
//Task Management

const getFileNameFromUrl = (url = "") => {
  try {
    const decoded = decodeURIComponent(url.split("?")[0]);
    return decoded.substring(decoded.lastIndexOf("/") + 1) || "Attachment";
  } catch (e) {
    return "Attachment";
  }
};

const isImageUrl = (url = "") =>
  /\.(png|jpe?g|gif|webp)$/i.test(url.split("?")[0]);

// The list/detail APIs return multiple attachments as a single comma-separated
// string on task_file_name.
const parseAttachmentList = (value) => {
  if (!value) return [];
  return String(value)
    .split(",")
    .map((url) => url.trim())
    .filter(Boolean);
};

const CreateTaskForm = (props) => {
  const [CreateTaskConfig, setCreateTaskConfig] = useState(TaskFormConfig);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const [taskConfigs, setTaskConfigs] = useState([]);
  const [setViewTask, setViewTaskById] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [roleArr, setRoleArr] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [previewAttachmentUrl, setPreviewAttachmentUrl] = useState(null);
  // Attachments removed from view locally (client-side only — there's no
  // per-file delete API, so this just hides it from the card list until the
  // user uploads new files and saves).
  const [removedAttachmentUrls, setRemovedAttachmentUrls] = useState([]);
  const { state } = useLocation();
  let data = state?.data;
  let id = state?.data.id;
    const edit = state?.edit;
  // Seeded from the list row passed via navigation state, but the list API
  // may not include media_file_path — populateViewFormFrEdit() below
  // refreshes this once the full task record (findTaskById) loads, so
  // existing attachments still show up even if the initial row lacked it.
  const [mediaFilePath, setMediaFilePath] = useState(state?.data?.media_file_path || null);
  // The View Task screen (TaskInfo.js) actually shows the existing attachment
  // via this field, not media_file_path — mirror that here so Edit mode shows
  // the same attachment the View screen already displays.
  const [taskFileName, setTaskFileName] = useState(state?.data?.task_file_name || null);
  const [fileObjs, setFileObjs] = useState([]);

  let downloadAttachmentURL =
    process.env.REACT_APP_APP_SERVER_ADDRESS +
    "/" +
    process.env.REACT_APP_CORE_CONTEXT_PATH_NAME +
    "/download/download_attachments/?directoryPath=" +
    mediaFilePath +
    "&fileName=Tasks.zip";

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(taskmanagementschema[activeTab]),
    mode: "all",
  });

  useEffect(() => {
    getInitData();
  }, []);
  // GET
  async function getViewData() {
    const userProfile = await getData(getThemeURL);
          const state_id = userProfile[0]?.state_id;
          setStateId(state_id);
    var getViewData = await getData(getTaskListURL.replace("STATEID",state_id));
    // setViewTask(getViewData);
    if (id) {
      await populateViewFormFrEdit(id);
    }
  }

  //EDIT
  async function populateViewFormFrEdit(id) {
    var viewData = await postDataWithBody(findTaskById, [id], {});
    viewData = viewData[0];
    setViewTaskById(viewData);
    reset(viewData);
    // findTaskById may not return these fields at all — don't let a missing
    // field here clobber a good value already carried over from the list row.
    setMediaFilePath((prev) => viewData?.media_file_path || prev);
    setTaskFileName((prev) => viewData?.task_file_name || prev);
  }

  const GenerateForm = (fields, register, errors, control) => {
    return (
      <div>
        {taskConfigs.length > 0 && roleArr.length > 1 && (
          <FormHandler
            register={register}
            errors={errors}
            fields={fields}
            control={control}
            editId={id}
            columns={2}
            getValues={getValues}
            fileObjs={fileObjs}
            setFileObjs={setFileObjs}
            existingFileCount={visibleAttachments.length}
          />
        )}
      </div>
    );
  };

  const generateTabsData = (tabWiseData) => {
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    return tabWiseData;
  };

  const submitHandler = async (data, e) => {
    setLoader(true);
    setIsSubmitting(true); // Disable the button
    e.preventDefault();
    const formData = new FormData();

    // Existing attachments the user kept (after any X-to-remove clicks) have
    // to ride back under task_media_file too — the backend only accepts
    // attachments as files on that field, not as a taskFileName URL string.
    // Re-fetch each kept URL into a Blob so it can be re-appended as a file
    // alongside newly picked ones.
    const keptAttachmentFiles = (
      await Promise.all(
        visibleAttachments.map(async (url) => {
          try {
            const res = await fetch(url);
            const blob = await res.blob();
            return new File([blob], getFileNameFromUrl(url), { type: blob.type });
          } catch (err) {
            console.error("Failed to re-fetch existing attachment:", url, err);
            return null;
          }
        })
      )
    ).filter(Boolean);

    Object.entries(data).forEach(([key, value]) => {
      if (key === "task_media_file") {
        // Handling file uploads correctly
        if (value && value.length > 0) {
          value.forEach((file) => formData.append(key, file));
        }
      } else if (key === "roleEntity") {
        // Skip appending `roleEntity` if it's an object (remove it from formData)
        // Alternatively, you could append specific properties if needed
        // Example: formData.append('roleEntityName', value.name);
        return;
      } else if (key === "taskFileName" || key === "media_file_path") {
        // Read-only fields populated by reset(viewData) — the kept
        // attachments are re-sent as files above instead, so never resubmit
        // these as-is.
        return;
      } else {
        formData.append(key, value);
      }
    });

    keptAttachmentFiles.forEach((file) => formData.append("task_media_file", file));

    // Always append 'status' payload
    formData.append("status", true);
    formData.append("state_id", stateId);
    formData.append("task_type_id", 341);

    let res;
    const headers = {};
    if (id) {
      formData.append("id", id);
      res = await putDataWithBody(updateTaskURL, formData, headers);
    } else {
      res = await postDataWithBody(createTaskURL, formData, headers);
    }

    if (res.status === "success") {
      toast.success(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
      navigate("/planning/view-task");
    } else {
      toast.error(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
    }
    setIsSubmitting(false); // Re-enable the button
    setLoader(false);
  };


  const handleConfirmCancel = () => {
    // Basic form reset
    reset({});
    
    // Clear fileObjs state
    setFileObjs([]);
    
    // Force re-render the form by changing the key
    setFormKey(prevKey => prevKey + 1);
    
    // Close the modal
    setShowCancelModal(false);
  };



  async function getInitData() {
    setLoader(true);
    await getTaskConfigs();
    await fetchAllRoles();
    // await getTaskStatus();
    await getViewData();
    setLoader(false);
    if (id) {
      populateViewFormFrEdit(id);
    }
  }
  async function fetchAllRoles() {
    let rolearr = await getData(getAllActiveRole);
    setRoleArr(rolearr);
    let roleFrDropdown = [];
    for (let role in rolearr) {
      roleFrDropdown.push({
        label: rolearr[role].name,
        value: rolearr[role].id,
      });
    }
    CreateTaskConfig[0].fields[2]["options"] = roleFrDropdown;
    setCreateTaskConfig(CreateTaskConfig);
  }
  async function getTaskConfigs() {
    const userProfile = await getData(getThemeURL);
          const state_id = userProfile[0]?.state_id;
    let res = await postDataWithBody(
      `${getTaskConfigsURL}/${state_id}`,
      ["TSK_PRIOR", "INCDNT_CAT", "TSK_STAT", "TSK_TYP"],
      {}
    );
    setTaskConfigs(res);
    let config_type = {};
    for (let config in res) {
      if (config_type[res[config].category_name]) {
        config_type[res[config].category_name].push({
          label: res[config].value,
          value: res[config].id,
        });
      } else {
        config_type[res[config].category_name] = [
          { label: res[config].value, value: res[config].id },
        ];
      }
    }
    //alert(config_type["INCDNT_CAT"])
    CreateTaskConfig[0].fields[0]["options"] = config_type["INCDNT_CAT"];
    CreateTaskConfig[0].fields[2]["options"] = config_type["TSK_PRIOR"];
    setCreateTaskConfig(CreateTaskConfig);
  }
  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  // Existing attachments still kept count toward the 3-file limit, so this must be
  // computed before the form (which receives the count) is built below.
  const visibleAttachments = parseAttachmentList(taskFileName).filter(
    (url) => !removedAttachmentUrls.includes(url)
  );

  const tabsData = generateTabsData(CreateTaskConfig);

  return (
    <div className="mt-4">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />

      <div className="form-body">
        <div className="registration__form--body">
          <form key={formKey} onSubmit={handleSubmit(submitHandler)} name="CreateTaskRegForm">
            <div>
              {tabsData?.map((tab) => (
                <>
                  {tab.id === activeTab && (
                    <>
                      <div>{tab.component}</div>
                    </>
                  )}
                </>
              ))}
            </div>

            <div>
              {id && visibleAttachments.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {visibleAttachments.map((url) => (
                    <div key={url} style={{ position: "relative", width: "120px", margin: "8px" }}>
                      <div style={{ position: "relative", width: "100%", height: "120px", display: "flex", flexDirection: "column" }}>
                        <div
                          style={{
                            position: "absolute",
                            top: "4px",
                            right: "4px",
                            zIndex: 1,
                            borderRadius: "50%",
                            padding: "2px",
                            boxShadow: "0 1px 3px rgba(56, 54, 54, 0.2)",
                            cursor: "pointer",
                          }}
                          title="Remove attachment"
                          onClick={() => setRemovedAttachmentUrls((prev) => [...prev, url])}
                        >
                          <Rejectedicon width="1rem" height="1rem" />
                        </div>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            background: "#f5f5f5",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() => setPreviewAttachmentUrl(url)}
                        >
                          {isImageUrl(url) ? (
                            <img
                              src={url}
                              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                              alt={getFileNameFromUrl(url)}
                            />
                          ) : (
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#eef2f7" }}>
                              <FileText width="2rem" height="2rem" color="#c0392b" />
                            </div>
                          )}
                        </div>
                        <div style={{ marginTop: "4px", width: "100%", minHeight: "40px", display: "flex", alignItems: "center" }}>
                          <span
                            style={{
                              fontSize: "12px",
                              lineHeight: 1.3,
                              wordBreak: "break-word",
                              textAlign: "center",
                              width: "100%",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {getFileNameFromUrl(url)}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : id && mediaFilePath ? (
                <span className="multi_file_uploaded cursor-pointer ">
                  <div
                    onClick={() =>
                      downloadFile(
                        downloadAttachmentURL,
                        "Tasks" + new Date().getTime() + ".zip"
                      )
                    }
                  >
                    <PaperClipIcon className="cursor-pointer" /> Attached files
                  </div>
                </span>
              ) : (
                ""
              )}
              {previewAttachmentUrl && (
                <PreviewFile
                  file={{ name: getFileNameFromUrl(previewAttachmentUrl), url: previewAttachmentUrl }}
                  show={!!previewAttachmentUrl}
                  previewHandler={() => setPreviewAttachmentUrl(null)}
                  title="Attachment Preview"
                />
              )}
            </div>

            <div className="d-flex justify-content-center">
              {tabsData.length - 1 === activeTab && (
                <>
                  <Button
                    type="submit"
                    className="mx-2"
                    variant="primary"
                    disabled={isSubmitting} // Disable when submitting
                  >
                    {edit? t("Update") : t("saveAndSubmit")}
                  </Button>
                  {!edit && <Button
                    type="button"
                    variant="primary"
                    className="mx-2"
                    onClick={handleCancelClick}
                    // Disable cancel button when form is submitting
                  >
                    Cancel
                  </Button>}
                </>
              )}
            </div>
          </form>
        </div>
      </div>
        <Modal
              show={showCancelModal}
              onHide={() => setShowCancelModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Would you like to clear the input values?
              </Modal.Body>
              <Modal.Footer>
                <button className="btn" style={{
                  backgroundColor: 'lightgray',
                  color: '#000',
                  marginRight: '10px'
                }} onClick={() => setShowCancelModal(false)}>
                  No
                </button>
                <button className="btn" style={{
                  backgroundColor: 'green',
                  color: '#fff'
                }} onClick={handleConfirmCancel}>
                  Yes
                </button>
              </Modal.Footer>
            </Modal>
    </div>
  );
};
export default CreateTaskForm;
